import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './LocationPickerLink.css';

interface ILocationPickerLinkProps {
  size: 'small' | 'big';
  onClick(): void;
}

export const LocationPickerLink: React.FC<React.PropsWithChildren<ILocationPickerLinkProps>> = ({
  children,
  size,
  onClick,
}) => {
  return (
    <span className={clsx(styles['container'], styles[size])} onClick={onClick}>
      {children}
    </span>
  );
};
